// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__25DwG","dragIcon":"Choice_dragIcon__3gF4r","left":"Choice_left__3ucMa","input":"Choice_input__1zlov"};